import zhTW from "./zh-TW";
export default zhTW;
